/*
 * Elysian Edge redesign: product page behaviour (Sprint 7). Loaded on the product template only (layout/theme.liquid).
 * Next's slider, zoom, lightbox, variant switching, add to bag and sticky bar are untouched; this file only adds what the new markup needs.
 */
(() => {
  'use strict'

  // Accordions that are "open by default" start closed on phones, so the product page stays short (the description alone is several screens).
  // They sit well below the fold there, so closing them at DOMContentLoaded shifts nothing the visitor can see.
  const phone = window.matchMedia('(max-width: 639px)')
  const collapse = () => {
    if (!phone.matches) return
    document.querySelectorAll('details.ee-pdp-acc[data-ee-open-desktop][open]').forEach((el) => el.removeAttribute('open'))
  }
  collapse()

  // Gallery thumbnails are Next's swiper pagination bullets: <a role="navigation"> with no name (axe: landmark-unique). Make them named buttons ("Show image 2 of 4").
  // Next builds the bullets after DOMContentLoaded and rebuilds them when the variant changes, so this watches the gallery column.
  const article = document.querySelector('.m6pr.ee-pdp')
  const gallery = article && article.querySelector('.l4pr-container')
  if (gallery) {
    const template = article.dataset.eeThumbLabel || 'Show image {n} of {total}'
    const set = (el, name, value) => { if (el.getAttribute(name) !== value) el.setAttribute(name, value) }
    const label = () => {
      const list = [...gallery.querySelectorAll('.swiper-custom-bullets .swiper-pagination-bullet')]
      list.forEach((el, i) => {
        set(el, 'role', 'button')
        set(el, 'aria-label', template.replace('{n}', i + 1).replace('{total}', list.length))
      })
    }
    label()
    // Only an attribute that differs is written, so Swiper rewriting role (or this callback's own writes) cannot loop.
    new MutationObserver(label).observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['role'] })
  }
})()
